import $ from "jquery";

$(function () {
	$("#calloutButton")
		.on("mouseenter", () => {
			$("#calloutImage").addClass("hovered");
		})
		.on("mouseleave", () => {
			$("#calloutImage").removeClass("hovered");
		});
});
